import store from '$redux/store';
import {ApiRoute} from '$constants/api';
import axiosInstance from '$api/index';

interface NewPaymentPayload {
  payment: {
    patient_id: number;
  };
}

interface NewPaymentResponse {
  success: boolean;
  data: {
    id: number;
    amount: number | null;
    patient_id: number;
    description: string | null;
    patient_full_name: string;
    invoice_number: string;
    billing_date: string;
    payment_method: string | null;
    status: string;
  };
  message: string;
}

export const createNewPayment = async (
  payload: NewPaymentPayload
): Promise<NewPaymentResponse> => {
  const token = store.getState().auth.token;

  const response = await axiosInstance.post(
    ApiRoute.NewPayment,
    {
      payment: {
        patient_id: payload.payment.patient_id,
      },
    },
    {
      headers: {
        Authorization: token,
      },
    }
  );
  return response.data;
};
